module.exports = __webpack_public_path__ + "img/company_intro_en.0e420f50.png";